module.exports = __webpack_public_path__ + "static/media/iwc_chronograph.ae337ca0.jpg";